export type ReaderFont = 'serif' | 'kai'
export type ReaderTheme = 'paper' | 'night'

export interface ReaderSettings {
  fontSize: number
  fontFamily: ReaderFont
  theme: ReaderTheme
}

export const READER_SETTINGS_STORAGE_KEY = 'nf.reader-settings'

export const DEFAULT_READER_SETTINGS: ReaderSettings = {
  fontSize: 18,
  fontFamily: 'serif',
  theme: 'paper',
}

export function normalizeReaderSettings(value: unknown): ReaderSettings {
  const input = value && typeof value === 'object' ? value as Partial<ReaderSettings> : {}
  return {
    fontSize: typeof input.fontSize === 'number' ? Math.min(24, Math.max(16, input.fontSize)) : DEFAULT_READER_SETTINGS.fontSize,
    fontFamily: input.fontFamily === 'kai' || input.fontFamily === 'serif' ? input.fontFamily : DEFAULT_READER_SETTINGS.fontFamily,
    theme: input.theme === 'night' || input.theme === 'paper' ? input.theme : DEFAULT_READER_SETTINGS.theme,
  }
}

export function loadReaderSettings(): ReaderSettings {
  if (typeof localStorage === 'undefined') return DEFAULT_READER_SETTINGS
  try {
    const saved = localStorage.getItem(READER_SETTINGS_STORAGE_KEY)
    return saved ? normalizeReaderSettings(JSON.parse(saved)) : DEFAULT_READER_SETTINGS
  } catch {
    return DEFAULT_READER_SETTINGS
  }
}

export function saveReaderSettings(settings: ReaderSettings) {
  if (typeof localStorage === 'undefined') return
  localStorage.setItem(READER_SETTINGS_STORAGE_KEY, JSON.stringify(settings))
}

export function readerFontFamily(font: ReaderFont) {
  return font === 'kai'
    ? "var(--nf-font-reading-kai), 'LXGW WenKai Screen', KaiTi, serif"
    : "var(--nf-font-reading-song), 'Noto Serif SC', 'Source Han Serif SC', 'Songti SC', Georgia, serif"
}

